import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShield: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconShield"><Path d="M12.7696 2.22393C12.2693 2.06208 11.7307 2.06208 11.2304 2.22393L4.73045 4.32687C3.69887 4.66062 3 5.62126 3 6.70548V11.9128C3 14.573 4.21165 16.5929 5.90547 18.2034C7.58545 19.8008 9.76777 21.0223 11.7626 22.0984C11.9108 22.1784 12.0892 22.1784 12.2374 22.0984C14.2322 21.0223 16.4145 19.8008 18.0945 18.2034C19.7883 16.5929 21 14.573 21 11.9128V6.70548C21 5.62126 20.3011 4.66061 19.2696 4.32687L12.7696 2.22393Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShield;
